import { Controller } from '@hotwired/stimulus'

// Job price editor inside the work list table. Attached to the same element
// as the `modal` controller; saves the edited price back to the server with
// fetch and updates the row + dialog in place on success.
export default class extends Controller {
  static targets = ['excludingField', 'includingField', 'vat', 'save']
  static values = { jobId: Number, t1: String, t2: String }

  connect() {
    this.field = 'including'
  }

  track(event) {
    this.field = event.target === this.excludingFieldTarget ? 'excluding' : 'including'
  }

  async save() {
    const field = this.field
    const value = field === 'excluding' ? this.excludingFieldTarget.value : this.includingFieldTarget.value
    const token = this.csrfToken()
    const body = new URLSearchParams({
      authenticity_token: token,
      t1: this.t1Value,
      t2: this.t2Value
    })
    body.set(field === 'excluding' ? 'price_excluding_vat' : 'price_including_vat', value)

    this.saveTarget.disabled = true
    try {
      const response = await fetch(`/jobs/${this.jobIdValue}/update_price`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-CSRF-Token': token },
        body
      })
      const json = await response.json()

      if (json.success) {
        const row = this.element.closest('tr')
        const rowPrice = row?.querySelector('span.price-including-vat')
        const rowBeforeVat = row?.querySelector('span.price-before-vat')
        const rowVat = row?.querySelector('span.price-vat-amount')
        const rowOutstanding = row?.querySelector('span.customer-outstanding-money')
        if (rowPrice) rowPrice.textContent = json.price_including_vat
        if (rowBeforeVat) rowBeforeVat.textContent = json.price_excluding_vat
        if (rowVat) rowVat.textContent = json.price_vat
        if (rowOutstanding) rowOutstanding.textContent = json.customer_outstanding_money
        this.vatTarget.textContent = json.price_vat
        this.excludingFieldTarget.value = json.price_excluding_vat
        this.includingFieldTarget.value = json.price_including_vat
        this.modalController.close()
      } else {
        alert('Could not update price')
      }
    } catch (error) {
      alert('Could not update price')
    } finally {
      this.saveTarget.disabled = false
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
  }

  get modalController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'modal')
  }
}
